import { render, staticRenderFns } from "./CompareEconomicEditor.vue?vue&type=template&id=56c5959e"
import script from "./CompareEconomicEditor.vue?vue&type=script&lang=js"
export * from "./CompareEconomicEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports